/* eslint-disable indent */
import React, { useState } from 'react';
import { Link } from 'gatsby';
import { Menu as MenuIcon, Favorite as HeartIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { slide as Menu } from 'react-burger-menu';
import logoAlt from '../../img/logo-alt.svg';
import TopAlert from './TopAlert';

function SiteNavbar() {
  const siteConfig = useSelector((state) => state.siteConfig);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const handleState = (state) => {
    setIsOpen(state.isOpen);
  };

  const drawerMenu = () => {
    return (
      <Menu
        right
        width={350}
        isOpen={isOpen}
        onStateChange={(state) => handleState(state.isOpen)}
        customBurgerIcon={false}
        className='top-0'
        menuClassName='bg-neutral pt-12 px-5'
        crossButtonClassName='left-4 right-auto'
        crossClassName='bg-base-300 !h-5'
        itemListClassName='p-4'
        itemClassName='text-neutral-content font-semibold mb-2 last:mb-0 py-1 md:py-1.5 no-underline hover:underline border-0'
        noOverlay
      >
        <div className='mx-0 mb-2.5 border-b-2 border-b-neutral-content pb-2.5 text-xl hover:no-underline'>
          Tools
        </div>
        <Link
          to='/am-i-registered-to-vote/'
          title='Check your registration status'
        >
          Check your registration status
        </Link>
        <Link to='/register-to-vote/' title='Register to vote'>
          Register to vote
        </Link>
        <Link to='/futurevoter/' title='FutureVoter - Pre-register to vote'>
          FutureVoter - Pre-register to vote
        </Link>
        <Link to='/absentee-mail-ballot/' title='Request your mail-in ballot'>
          Request your mail-in ballot
        </Link>
        <Link to='/absentee-mail-ballot/' title='Request your absentee ballot'>
          Request your absentee ballot
        </Link>
        <Link to='/upcoming-elections/' title='Find upcoming elections'>
          Find upcoming elections
        </Link>
        <Link to='/election-reminders/' title='Sign up for election reminders'>
          Sign up for election reminders
        </Link>
        <Link to='/pav/' title='Sign up for permanent absentee voting'>
          Sign up for permanent absentee voting
        </Link>
        <Link to='/where-to-vote/' title='Find out where to vote'>
          Find out where to vote
        </Link>
        <Link to='/ballot-tracker/' title='Track your absentee or mail ballot'>
          Track your absentee or mail ballot
        </Link>
        <Link
          to='/provisional-ballot-tracker/'
          title='Track your provisional ballot'
        >
          Track your provisional ballot
        </Link>
        <Link
          to='/local-election-offices/'
          title='Contact your election office'
        >
          Contact your election office
        </Link>
      </Menu>
    );
  };

  return (
    <header>
      <TopAlert />
      <div className='bg-neutral px-4 py-2 md:px-20'>
        <div className='mx-auto max-w-7xl'>
          <nav className='navbar space-x-2 p-0'>
            <div className='navbar-start'>
              <Link to='/' title='VoteAmerica' className='logo border-0'>
                <img
                  className='mx-auto h-10 p-0 md:h-12'
                  src={logoAlt}
                  alt='VoteAmerica'
                />
              </Link>
            </div>
            <div className='navbar-end space-x-2'>
              {siteConfig.showDistractions && (
                <>
                  <a
                    className='btn hidden border-2 border-secondary bg-secondary font-semibold uppercase text-secondary-content hover:border-primary hover:bg-primary md:flex'
                    href='https://secure.actblue.com/donate/voteamerica-website?refcode=www.voteamerica.org'
                    target='_blank'
                    rel='noopener'
                  >
                    <HeartIcon />
                    <span>Donate</span>
                  </a>
                  {drawerMenu()}
                  <button
                    className='btn border-2 border-secondary bg-secondary font-semibold uppercase text-secondary-content hover:border-primary hover:bg-primary'
                    onClick={toggleDrawer}
                    type='button'
                  >
                    <MenuIcon />
                    <span className='hidden md:inline-block'>Menu</span>
                  </button>
                </>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default SiteNavbar;
